import { Card, Button, Container } from 'react-bootstrap';
import { GalleryItem } from '../models/models';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

export const GallerySection = ({ data = undefined, handleOnClick }: { data: GalleryItem[] | undefined, handleOnClick: (galleryItem: GalleryItem) => void }) => {
  if (!data) return null;

  return (
    <section id="gallery" className="pb-5">
      <Container className="my-5">
        <h2 className=' mb-3'>Gallery</h2>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {data.map((galleryItem, index) => (
            <SwiperSlide key={index}>
              <Card 
                className='shadow text-white card-ratio bg-primary' 
                style={{
                  backgroundImage: `url(${galleryItem.imageOriginal})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  minHeight: '300px',
                  color: 'white',
                }}
              >
                <div className="card-content">
                  <Card.Body className="d-flex flex-column justify-content-end h-100">
                    <Card.Text className="small mb-2">{galleryItem.period} {galleryItem.place && ` | ${galleryItem.place}`}</Card.Text>
                    {galleryItem.place && ` | ${galleryItem.place}`}
                    <Card.Title className="fw-bold mb-4">{galleryItem.title}</Card.Title>
                    <Button variant="light" className="align-self-start" onClick={()=> handleOnClick(galleryItem)}>Read more</Button>
                  </Card.Body>
                </div>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};
